// extracted by mini-css-extract-plugin
export var details = "_gx-0";
export var inspectorPopover = "_gx-1";